import React, { useEffect, useState } from "react"
import SEO from "../components/seo"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import ChangeLang from "../components/changeLang"
import GetHeader from "../components/getHeader"
import { useLocation } from "@reach/router"
import Image from "gatsby-image"
import "./project.css"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import createDOMPurify from "dompurify"

// These used to replace and cusotmize the boring arrows from react-slick
function NextArrow(props) {
  const { className, style, onClick, rightArrow } = props
  return (
    <div className={className} style={{ ...style }} onClick={onClick} role="button" tabIndex={0}>
      <Image fixed={rightArrow} style={{ right: "5px" }} alt="תמונה הבאה" />
    </div>
  )
}

function PrevArrow(props) {
  const { className, style, onClick, rightArrow } = props
  return (
    <div className={className} style={{ ...style }} onClick={onClick} role="button" tabIndex={0}>
      <Image fixed={rightArrow} style={{ right: "15px", transform: "rotateY(180deg)" }} alt="תמונה קודמת" />
    </div>
  )
}

const HeProject = ({ data }) => {
  const project = data.getProject.nodes[0]
  const homeButtonPic = data.homeButton.childImageSharp.fixed
  const rightArrow = data.rightArrow.childImageSharp.fixed
  const arrowUp = data.arrowUp.childImageSharp.fixed
  const allSlidersPics = project.pagesPics
  const technical = project.desc
  const [DOMPurify, setDOMPurify] = useState()
  const location = useLocation()

  useEffect(() => {
    if (typeof window !== `undefined`) {
      setDOMPurify(createDOMPurify(window))
    }

    // Used to detect if the page was forwarded or just reloaded, in case it was forwaded so don't active the intersection api immediately when scrolling up, only after 1 second
    // This is used because if I didn't do it, so intersection api would fire immediately when page got 'pushed' because there's scrollTo(0,0)
    // and I want to avoid it to  activate on initial load
    const time = location.action === "PUSH" && !location.state.noChange ? 800 : 0
    var observerGalleryHE
    setTimeout(() => {
      // Target when contents is on screen, and then drop down in animation
      const galleryProject = document.getElementById("galleryProject")
      const containerSliders = document.getElementsByClassName("container")
      const dynamicThresold = containerSliders.length === 1 ? [0.33] : [0.2, 0.53]

      observerGalleryHE = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // If there is only 1 slider
            if (containerSliders.length === 1) {
              if (entry.intersectionRatio > 0.3) {
                containerSliders[0].classList.add("active")
              }
            }

            // If there are 2 sliders
            else {
              if (entry.intersectionRatio > 0.2 && entry.intersectionRatio < 0.53) {
                containerSliders[0].classList.add("active")
              }
              if (entry.intersectionRatio > 0.53) {
                containerSliders[1].classList.add("active")
              }
            }
          })
        },
        { threshold: dynamicThresold }
      )

      observerGalleryHE.observe(galleryProject)
    }, time)

    return () => {
      if (observerGalleryHE) observerGalleryHE.disconnect()
    }
  }, [location.action])

  // settings for react slick carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    nextArrow: <NextArrow rightArrow={rightArrow} />,
    prevArrow: <PrevArrow rightArrow={rightArrow} />,
  }

  let changeCursorToGrab = () => {
    document.getElementsByClassName("slick-list")[0].style.cursor = "grabbing"
  }

  let changeGrabToUngrab = () => {
    document.getElementsByClassName("slick-list")[0].style.cursor = "grab"
  }

  // Hiding the slider when clicking on menu to avoid lag
  let handleSliderLagOnMenuClick = () => {
    document.getElementById("galleryProject").style.visibility = "hidden"
  }

  // Using this to achieve random keys for each item on the map in technical info in p
  let guidGenerator = () => {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4()
  }

  if (!DOMPurify) {
    return (
      <Layout>
        <div id="project" className="hebrew rollingPage">
          <SEO
            title={"פרטי הפרוייקט" + " " + project.heTitle}
            description={project.heAbout.heAbout.replace(/<p>|<\/p>|<h2>|<\/h2|<ul>|<\/ul|<li>|<\/li>|<b>|<\/b>|"|&#11015/g, "").replace(/\n/g, " ")}
            keywords={[project.heTitle].concat(project.techList.map((tech) => tech.image.title))}
          />

          <div mimicnav="true"></div>
          <span onClick={handleSliderLagOnMenuClick} role="button" tabIndex={0}>
            <GetHeader />
          </span>
          <ChangeLang fromProject={true} slug={project.enSlug} />
          <Link to="/he" state={{ noChange: true }}>
            <Image fixed={homeButtonPic} className="homeButton" role="button" tabIndex={0} alt="עבור לדף הבית" />
          </Link>

          <article>
            <div className="links">
              {project.uriLink !== "none" && (
                <a href={project.uriLink} target="_blank" rel="noopener noreferrer">
                  <button>עבור לאתר</button>
                </a>
              )}
            </div>

            <h1>{project.heTitle}</h1>

            <h2>סקירה כללית</h2>

            <div className="wrapperInnerContent">
              <div className="skeleton overview"></div>
              <div className="skeleton overview"></div>
              <div className="skeleton overview"></div>
              <div className="skeleton overview"></div>
            </div>

            <div id="galleryProject" role="img" aria-label={`Pictures of ${project.heTitle}`}>
              <h2 className="skeleton"> תמונות</h2>

              {allSlidersPics.map((specificSlider) => (
                <React.Fragment key={specificSlider.id}>
                  {specificSlider.heTitle !== null && (
                    <div className="container skeleton active">
                      <Slider {...settings}>
                        {specificSlider.pagePics.map((page) => (
                          <div key={page.id} onMouseDown={changeCursorToGrab} onMouseUp={changeGrabToUngrab} role="slider" tabIndex={0}>
                            <Image
                              fluid={page.fluid}
                              style={{ maxHeight: "75vh" }}
                              imgStyle={{ objectFit: "contain" }}
                              draggable={true}
                              alt={specificSlider.heTitle + " - " + project.heTitle}
                            />
                          </div>
                        ))}
                      </Slider>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
            <div id="techUsed">
              <h2>טכנולוגיות שהשתמשתי בהם לפרוייקט</h2>
              <div>
                {project.techList.map((tech) => (
                  <div key={tech.image.title} className="tech">
                    <Image fixed={tech.image.fixed} alt={tech.image.title} title={tech.image.title} />
                    <h3>{tech.image.title}</h3>
                  </div>
                ))}
              </div>
            </div>
            {technical !== null && (
              <div id="technicalInfo">
                <h2>מידע טכני</h2>
                <div className="wrapperInnerContent">
                  {technical.desc.map((paragraph) => (
                    <div key={paragraph.id} className="paragraph">
                      <h3>{paragraph.titleHE}</h3> -{" "}
                      {paragraph.fieldHE.content.map((line, index) => (
                        <React.Fragment key={guidGenerator()}>
                          <p>{line.content[0].value}</p>
                          {paragraph.fieldHE.content.length - 1 > index && <div className="forSpacing"></div>}
                        </React.Fragment>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </article>

          <footer>
            <span>
              תודה על זמנך!{" "}
              <span role="img" aria-label="happy emoji">
                😊
              </span>
            </span>
            <div onClick={() => window.scrollTo(0, 0)} role="button" tabIndex={0}>
              <Image fixed={arrowUp} className="arrowUp" alt="קפוץ לתחילת העמוד" />
            </div>

            <small>איתי שיף ©</small>
          </footer>
        </div>
      </Layout>
    )
  }
  return (
    <Layout>
      <div id="project" className="hebrew rollingPage">
        <SEO
          title={"פרטי הפרוייקט" + " " + project.heTitle}
          description={project.heAbout.heAbout.replace(/<p>|<\/p>|<h2>|<\/h2|<ul>|<\/ul|<li>|<\/li>|<b>|<\/b>|"|&#11015/g, "").replace(/\n/g, " ")}
          keywords={[project.heTitle].concat(project.techList.map((tech) => tech.image.title))}
        />

        <div mimicnav="true"></div>
        <span onClick={handleSliderLagOnMenuClick} role="button" tabIndex={0}>
          <GetHeader />
        </span>
        <ChangeLang fromProject={true} slug={project.enSlug} />
        <Link to="/he" state={{ noChange: true }}>
          <Image fixed={homeButtonPic} className="homeButton" role="button" tabIndex={0} alt="עבור לדף הבית" />
        </Link>

        <article>
          <div className="links">
            {project.uriLink !== "none" && (
              <a href={project.uriLink} target="_blank" rel="noopener noreferrer">
                <button>עבור לאתר</button>
              </a>
            )}
          </div>

          <h1>{project.heTitle}</h1>

          <h2>סקירה כללית</h2>

          <div className="wrapperInnerContent" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(project.heAbout.heAbout.replace(/\n/g, "<br/>")) }} />

          <div id="galleryProject" role="img" aria-label={`Pictures of ${project.heTitle}`}>
            {allSlidersPics.length === 1 && <h2>תמונות</h2>}

            {allSlidersPics.map((specificSlider) => (
              <React.Fragment key={specificSlider.id}>
                {specificSlider.heTitle !== null && (
                  <div className="container">
                    {allSlidersPics.length > 1 && <h2 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(specificSlider.heTitle) }} />}

                    <Slider {...settings}>
                      {specificSlider.pagePics.map((page) => (
                        <div key={page.id} onMouseDown={changeCursorToGrab} onMouseUp={changeGrabToUngrab} role="slider" tabIndex={0}>
                          <Image
                            fluid={page.fluid}
                            style={{ maxHeight: "75vh" }}
                            imgStyle={{ objectFit: "contain" }}
                            draggable={true}
                            alt={specificSlider.heTitle + " - " + project.heTitle}
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
          <div id="techUsed">
            <h2>טכנולוגיות שהשתמשתי בהם לפרוייקט</h2>
            <div>
              {project.techList.map((tech) => (
                <div key={tech.image.title} className="tech">
                  <Image fixed={tech.image.fixed} alt={tech.image.title} title={tech.image.title} />
                  <h3>{tech.image.title}</h3>
                </div>
              ))}
            </div>
          </div>
          {technical !== null && (
            <div id="technicalInfo">
              <h2>מידע טכני</h2>
              <div className="wrapperInnerContent">
                {technical.desc.map((paragraph) => (
                  <div key={paragraph.id} className="paragraph">
                    <h3>{paragraph.titleHE}</h3> -{" "}
                    {paragraph.fieldHE.content.map((line, index) => (
                      <React.Fragment key={guidGenerator()}>
                        <p>{line.content[0].value}</p>
                        {paragraph.fieldHE.content.length - 1 > index && <div className="forSpacing"></div>}
                      </React.Fragment>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </article>

        <footer>
          <span>
            תודה על זמנך!{" "}
            <span role="img" aria-label="happy emoji">
              😊
            </span>
          </span>
          <div onClick={() => window.scrollTo(0, 0)} role="button" tabIndex={0}>
            <Image fixed={arrowUp} className="arrowUp" alt="קפוץ לתחילת העמוד" />
          </div>

          <small>איתי שיף ©</small>
        </footer>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query getSingleProjectHebrew($slug: String) {
    getProject: allContentfulProjects(filter: { heSlug: { eq: $slug } }) {
      nodes {
        uriLink
        heTitle
        enSlug
        heAbout {
          heAbout
        }
        pagesPics {
          id
          heTitle
          pagePics {
            id
            fluid(maxWidth: 1500, quality: 100) {
              ...GatsbyContentfulFluid
            }
          }
        }
        techList {
          image {
            title
            fixed(height: 70) {
              ...GatsbyContentfulFixed
            }
          }
        }
        desc {
          desc {
            id
            titleHE
            fieldHE {
              content {
                content {
                  value
                }
              }
            }
          }
        }
      }
    }
    homeButton: file(relativePath: { eq: "homeButton.png" }) {
      childImageSharp {
        fixed(height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    rightArrow: file(relativePath: { eq: "rightArrow.png" }) {
      childImageSharp {
        fixed(height: 40) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    arrowUp: file(relativePath: { eq: "arrowUp.png" }) {
      childImageSharp {
        fixed(width: 27) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

export default HeProject
